export const TABS = {
  SUMMARY: 0,
  FINANCIAL_DETAILS: 1,
  PROPERTY_LOCATION: 2,
  PROPERTY_DETAILS: 3
};

export const PROPERTY_STATUS = {
  PRE_ORDER: 1,
  LIVE: 2,
  COMING_SOON: 3,
  INACTIVE: 4
};

export const PAYMENT_METHOD = {
  ACH_TRANSFER: 1,
  WIRE_TRANSFER: 2
};
